import { IdentifyResponse } from '@models/identify';

export function handleIdentificationSuccess(response: IdentifyResponse) {
    const { encryptedData } = response;
    const form = document.createElement('form');
    form.hidden = true;
    form.action = 'https://nice.checkplus.co.kr/CheckPlusSafeModel/checkplus.cb';
    const mInput = document.createElement('input');
    mInput.name = 'm';
    mInput.value = 'checkplusService';
    const dataInput = document.createElement('input');
    dataInput.name = 'EncodeData';
    dataInput.value = encryptedData;
    form.append(mInput);
    form.append(dataInput);
    document.body.appendChild(form);
    form.submit();
}
